import React from 'react';
import { Button, Typography } from '@primitives';
import DownloadIcon from '@icons/DownloadIcon';
import style from './style.module.scss';
import axiosInstance, { ApiKeys, getApiUrl } from '@cp/utils/ApiHelper';
import { Downloadtype } from '../../types';
import { toast } from '@primitives/Toast';

interface ISampleCSV {
  selectedAgency?: string;
}

export const onSampleCsvDownload = (selectedAgency: string, downloadType: Downloadtype) => {
  toast('Downloading file please wait', {
    type: 'info',
    icon: <DownloadIcon color={'var(--blue-base)'} />
  });
  const url = getApiUrl(ApiKeys.AGENCY_SERVICEABILITY_GET_STATIC_URLS);
  axiosInstance
    .get(url, { params: { downloadType } })
    .then(res => {
      window.open(res?.data?.preSignedGetUrl, '_blank');
    })
    .catch(err => {
      toast('Unable to download file please try again', { type: 'error' });
    });
};

function SampleCsv({ selectedAgency = 'DUMMY' }: ISampleCSV) {
  return (
    <div className={style.mainContainer}>
      <Typography variant={'p3'} className={style.text}>
        Columns to be included in CSV
      </Typography>
      <Typography variant={'p4'} className={style.pincodeText}>
        Pincode, District, State, DPD bucket, Agent Name, Agent Phone Number
      </Typography>

      <Button
        onClick={() => onSampleCsvDownload(selectedAgency, Downloadtype.SAMPLE_CSV)}
        variant="text"
        startAdornment={<DownloadIcon color={'var(--blue-base)'} />}
      >
        {' '}
        Sample CSV
      </Button>
    </div>
  );
}

export default SampleCsv;
